import { useQuery } from '@tanstack/react-query'
import { surveyApi } from '@/services/surveys/surveys'
import { SurveyType } from '@/interfaces/survey'

export const useGetSurveys = (type: SurveyType) => {
  return useQuery({
    queryKey: ['surveys', type],
    queryFn: () => surveyApi.getSurveys(type),
  })
}
